import { useState, useEffect } from "react"
import { v4 as uuidv4 } from 'uuid'
import { Card, Accordion } from 'react-bootstrap'
import { GroupSelect, OptionRange } from 'GroupSelect'
import { useSettings } from 'Settings'

const profiles = {
	"default" : {
		"disabled" : true,
		"values" : {
			"t_hrv_period" : 8192,
			"t_hrv_meas" : 128,
			"t_sts_period" : 8,
			"t_lts_period" : 1024,
			"t_hrv_low_period" : 256,
			"t_lts_hrv_low_period" : 32768
		}
	},
	"safe" : {
		"disabled" : true,
		"values" : {
			"t_hrv_period" : 8192,
			"t_hrv_meas" : 128,
			"t_sts_period" : 1,
			"t_lts_period" : 1,
			"t_hrv_low_period" : 256,
			"t_lts_hrv_low_period" : 32768
		}
	},
	"custom" : {
		"disabled" : false,
		"values" : {
			"t_hrv_period" : 8192,
			"t_hrv_meas" : 128,
			"t_sts_period" : 8,
			"t_lts_period" : 1024,
			"t_hrv_low_period" : 256,
			"t_lts_hrv_low_period" : 32768
		}
	}
}

const t_hrv_period_options =         OptionRange(0, 7, i => (2 ** i) * 256)
const t_hrv_meas_options =           OptionRange(0, 7, i => (2 ** i) * 16)
const t_sts_period_options =         OptionRange(0, 8, i => (2 ** i))
const t_lts_period_options =         OptionRange(0, 7, i => (4 ** i))
const t_hrv_low_period_options =     OptionRange(0, 7, i => (2 ** i) * 256)
const t_lts_hrv_low_period_options = OptionRange(0, 7, i => (4 ** i) * 2)

const options = {
	"t_hrv_period" : t_hrv_period_options,
	"t_hrv_meas" : t_hrv_meas_options,
	"t_sts_period" : t_sts_period_options,
	"t_lts_period" : t_lts_period_options,
	"t_hrv_low_period" : t_hrv_low_period_options,
	"t_lts_hrv_low_period" : t_lts_hrv_low_period_options
}

export default function TimingConfiguration() {
	const hook = useSettings()
	const [settings] = hook

	const mode_options = [
		{value : "default", label : "Default"},
		{value : "safe", label : "Safe"},
		{value : "custom", label : "Custom"}
	]

	function create_setting(name) {
		const opt = options[name]
		const state = settings['timing'][name];
		return (
			<GroupSelect
				key={uuidv4()}
				name={name}
				options={opt}
				value={state.value}
				onChange={(v) => state.setValue(v.value)}
				unit="ms"
				isDisabled={settings['timing']['mode'].value !== 'custom'}
			/>
		)
	}

	const setMode = (v) => {
		const current = profiles[v.value];

		settings['timing']['mode'].setValue(v.value);

		Object.entries(current.values).forEach(([key, value]) => {
			settings['timing'][key].setValue(current.values[key])
		})
		
	}

	return (
		<Card className="mb-3">
			<Card.Body>
				<Card.Title>Timing Configuration</Card.Title>
				<GroupSelect
					name="Mode"
					options={mode_options}
					value={settings['timing']['mode'].value}
					onChange={setMode}
					info={
					<>
						<p>
							<span>Default</span><br />
							<span className="text-muted"
								style={{ whiteSpace: 'nowrap'}}>
								use default values from EEPROM
							</span>
						</p>
						<p>
							<span>Safe</span><br />
							<span className="text-muted"
								style={{ whiteSpace: 'nowrap'}}>
								if power generated by harvester and application is unknown
							</span>
						</p>
						<p>
							<span>Custom</span><br />
							<span className="text-muted"
								style={{ whiteSpace: 'nowrap'}}>
								if you know what you are doing
							</span>
						</p>
					</>
					}
				/>
				<Accordion>
					<Accordion.Item eventKey="0">
						<Accordion.Header>Values</Accordion.Header>
						<Accordion.Body>
							{Object.entries(options).map(v => create_setting(v[0]))}
						</Accordion.Body>
					</Accordion.Item>
				</Accordion>
			</Card.Body>
		</Card>
	)
}
